/**
 * Filter to be applied to admin report
 */
import {SubscriptionSource, Dto, SubscriptionPeriodUnit, SubscriptionPlanType} from 'common';

export class AdminReportGroupFilter extends Dto {
    public query: string;
    public subscriptionPlanTypes: SubscriptionPlanType[];
    public subscriptionPeriodUnits: SubscriptionPeriodUnit[];
    public subscriptionSources: SubscriptionSource[];
    public renewable: boolean;
    public active: boolean;
    public applyRenewable: boolean; // These are toggles, so we need these to support a `show-all` scenario
    public applyActive: boolean; // These are toggles, so we need these to support a `show-all` scenario
    public supportsRenewable: boolean;
    public supportsActive: boolean;
    public supportsQuery: boolean;
    public supportsSubscriptionPlanTypes: boolean;
    public supportsSubscriptionPeriodUnits: boolean;
    public supportsSubscriptionSources: boolean;
    public supportsCloudAdminSubscriptionSource: boolean;
    public supportSubscriptionCustomPeriodUnit: boolean;

    constructor() {
        super();
        this.query = '';
        this.renewable = false;
        this.active = false;
        this.applyRenewable = false;
        this.applyActive = false;
        this.subscriptionPlanTypes = [];
        this.subscriptionPeriodUnits = [];
        this.subscriptionSources = [];
    }

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
